import { matchPath } from 'react-router-dom';
import { curryN, flip, noop } from 'lodash/fp';
export const getMenuNavigationProps = ({
  pathname,
  link: {
    href,
    to,
    target,
    onNavigate,
    children,
    decorator
  },
  enableIosTap,
  onClick = noop
}) => {
  const isCurrentRoute = !children && to === pathname;
  const className = 'mchNoDecorate';
  const clickEventName = enableIosTap ? 'onMouseUp' : 'onClick';
  const curriedClickHandler = curryN(2, flip(onClick));
  if (isCurrentRoute) {
    return {
      to,
      [clickEventName]: () => {
        if (window) {
          window.location.reload();
        }
      },
      className,
      decorator
    };
  }
  if (onNavigate) {
    return {
      as: 'div',
      role: 'button',
      [clickEventName]: onNavigate,
      decorator
    };
  }
  if (href) {
    const linkProps = {
      as: 'a',
      href,
      target,
      decorator
    };
    return {
      ...linkProps,
      [clickEventName]: curriedClickHandler(linkProps)
    };
  }
  if (to) {
    const linkProps = {
      to,
      target,
      className,
      decorator
    };
    return {
      ...linkProps,
      [clickEventName]: curriedClickHandler(linkProps)
    };
  }
  return {
    decorator
  };
};
export const matchPathActiveOn = (currentPath, activeOn) => {
  if (Array.isArray(activeOn)) {
    return activeOn.some(path => matchPath(currentPath, {
      path,
      exact: true
    }) !== null);
  }
  if (activeOn instanceof RegExp) {
    return activeOn.test(currentPath);
  }
  return false;
};
export const isActive = (link, currentPath) => link.to === currentPath || matchPathActiveOn(currentPath, link.activeOn);
export const isMainLinkActive = (link, currentPath) => {
  if (link.children) {
    return Object.values(link.children).some(child => isActive(child, currentPath));
  }
  return isActive(link, currentPath);
};